module.exports = __webpack_public_path__ + "img/kh.c08f207d.svg";